// /* /* eslint-disable react-hooks/exhaustive-deps */
// import React, { useEffect, useState } from 'react';
// import { useHeaderStates } from '../../Providers/HeaderStates';
// import { Link } from 'react-router-dom';
// import { Breadcrumbs } from '../../components/Breadcrumbs';
// import { Loading } from '../../components/Loading';
// import { baseUrlImg, handleGetData } from '../../Api';
// import { useStartupState } from '../../Providers/StartupState';
// import { format, parseISO } from 'date-fns';
// import { pt } from 'date-fns/locale';
// import { Controller, useForm } from 'react-hook-form';
// import * as S from './style';

// export const EventCopasul = () => {
//   const [data, setData] = useState(null);
//   const [optionsFilter, setOptionsFilter] = useState([]);
//   const [selectedYear, setSelectedYear] = useState('');

//   const { setTitle, setBgHeader } = useHeaderStates();
//   const { token, setError, loading, setLoading } = useStartupState();
//   const { control } = useForm();

//   useEffect(() => {
//     setError(null);
//     setLoading(true);
//     if (token) {
//       handleGetData(token, 'api/content/copasul/eventos/')
//         .then((response) => {
//           setData(response?.data?.items[0]?.data);
//           const dates = response?.data?.items[0]?.data?.eventos?.iv.map(
//             (item) => {
//               return item?.evento?.data;
//             },
//           );
//           const uniqueYears = [
//             ...new Set(
//               dates.map((date) => ({
//                 value: date,
//                 label: format(parseISO(date), 'yyyy'),
//               })),
//             ),
//           ];

//           setOptionsFilter(uniqueYears);

//           if (response?.status !== 200) {
//             throw new Error(response.message);
//           }
//         })
//         .catch((e) => {
//           setData(null);
//           console.log('Error =>', e.message);
//         })
//         .finally(() => {
//           setLoading(false);
//         });
//     }
//   }, [token]);

//   useEffect(() => {
//     setTitle(data?.titulo?.iv);
//     setBgHeader(data?.imagemHeader?.iv[0]);
//   });

//   const handleYearChange = (value) => {
//     setSelectedYear(value);
//   };

//   if (loading) {
//     return <Loading />;
//   } else {
//     return (
//       <div style={{ position: 'relative' }}>
//         <Breadcrumbs
//           content={data?.breadScrumb?.iv}
//           style={{ position: 'absolute' }}
//         />
//         <S.Container bgOurUnits={data?.imagemBackground?.iv[0]}>
//           <S.FormFilter>
//             <Controller
//               name="year"
//               control={control}
//               defaultValue=""
//               rules={{ required: true }}
//               render={({ field: { onChange } }) => (
//                 <select
//                   onChange={(e) => {
//                     onChange(e);
//                     handleYearChange(e.target.value);
//                   }}
//                 >
//                   <option value="">Escolha um ano</option>
//                   {optionsFilter.map((item) => (
//                     <option key={item.label} value={item.value}>
//                       {item.label}
//                     </option>
//                   ))}
//                 </select>
//               )}
//             />
//           </S.FormFilter>

//           {data &&
//             [...data?.eventos?.iv]
//               .reverse()
//               .filter((item) => {
//                 if (!selectedYear) return true;
//                 const year = item?.evento?.data;

//                 return year === selectedYear;
//               })
//               .map((item) => (
//                 <S.Card key={item?.id}>
//                   <S.ContentBox>
//                     <h3>
//                       {item?.evento?.data && (
//                         <S.SpanDate>
//                           {format(new Date(item?.evento?.data), 'dd MMM', {
//                             locale: pt,
//                           })}
//                         </S.SpanDate>
//                       )}
//                       {item?.evento?.titulo && item?.evento?.titulo}
//                     </h3>
//                     {item?.evento?.data && (
//                       <p>
//                         Data:
//                         <span>
//                           {format(
//                             parseISO(item?.evento?.data),
//                             "d 'de' MMMM 'de' yyyy",
//                             { locale: pt },
//                           )}
//                         </span>
//                       </p>
//                     )}
//                     {item?.evento?.conteudoAdicional && (
//                       <p>
//                         Local:
//                         <span>{item?.evento?.conteudoAdicional}</span>
//                       </p>
//                     )}
//                     {item?.evento?.link?.linkInterno && (
//                       <S.LinkHere>
//                         Faça sua inscrição
//                         <Link to={`${item?.evento?.link?.linkInterno}`}>
//                           {` ${item?.evento?.link?.tituloLink}`}.
//                         </Link>
//                       </S.LinkHere>
//                     )}
//                   </S.ContentBox>
//                   {item?.evento?.imagemEvento !== null && (
//                     <img
//                       src={`${baseUrlImg}${item?.evento?.imagemEvento[0]}`}
//                       alt="imagem do evento"
//                     />
//                   )}
//                 </S.Card>
//               ))}
//         </S.Container>
//       </div>
//     );
//   }
// };
//  */


/* eslint-disable react-hooks/exhaustive-deps */
// Importando os hooks e componentes necessários do React e outras bibliotecas
import React, { useEffect, useState } from 'react'; // useEffect e useState são hooks do React
import { useHeaderStates } from '../../Providers/HeaderStates'; // Importa o hook personalizado para gerenciar o estado do cabeçalho
import { Link } from 'react-router-dom'; // Importa o componente Link do React Router para navegação
import { Capa } from '../../components/Capa'; // Capa padrão das páginas internas (imagem do topo + trilha de navegação)
import { Loading } from '../../components/Loading'; // Componente de loading
import { baseUrlImg, handleGetData } from '../../Api'; // Funções para buscar dados e baseUrl de imagens
import { useStartupState } from '../../Providers/StartupState'; // Hook personalizado para o estado inicial da aplicação
import { format, parseISO, isValid } from 'date-fns'; // Funções de manipulação de data
import { pt } from 'date-fns/locale'; // Localização para português
import { Controller, useForm } from 'react-hook-form'; // Controle de formulários com react-hook-form
import * as S from './style'; // Importa os estilos do componente

// Converte a data do evento em um objeto Date válido (ou null quando ausente/inválida)
const getEventDate = (item) => {
  const rawDate = item?.evento?.data;
  if (!rawDate) return null;

  const date = parseISO(rawDate);
  return isValid(date) ? date : null;
};

// Componente principal do evento Copasul
export const EventCopasul = () => {
  // Declaração dos estados do componente
  const [data, setData] = useState(null); // Estado para armazenar os dados dos eventos
  const [optionsFilter, setOptionsFilter] = useState([]); // Estado para armazenar opções de filtro (anos)
  const [selectedYear, setSelectedYear] = useState(''); // Estado para armazenar o ano selecionado pelo usuário

  // Hooks personalizados para manipulação do estado do cabeçalho e estado inicial
  const { setTitle, setBgHeader } = useHeaderStates();
  const { token, setError, loading, setLoading } = useStartupState();

  // Hook de formulário
  const { control } = useForm();

  // Efeito colateral (useEffect) para buscar dados quando o token for atualizado
  useEffect(() => {
    setError(null); // Limpa erros ao iniciar o carregamento
    setLoading(true); // Define o loading como verdadeiro
    if (token) { // Verifica se o token está disponível
      // Chama a função que busca os dados dos eventos
      handleGetData(token, 'api/content/copasul/eventos/')
        .then((response) => {
          setData(response?.data?.items[0]?.data); // Atualiza os dados dos eventos com a resposta
          const eventos = response?.data?.items[0]?.data?.eventos?.iv ?? []; // Lista de eventos retornada pela API
          const uniqueYears = [ // Cria um array com anos únicos (Set sobre strings, não objetos)
            ...new Set(
              eventos
                .map((item) => getEventDate(item)) // Converte cada evento em uma data válida
                .filter(Boolean) // Descarta eventos sem data
                .map((date) => format(date, 'yyyy')), // Mantém apenas o ano
            ),
          ].sort((a, b) => Number(b) - Number(a)); // Anos mais recentes primeiro

          setOptionsFilter(uniqueYears); // Atualiza as opções de filtro com os anos únicos

          if (response?.status !== 200) { // Verifica se a resposta foi bem-sucedida
            throw new Error(response.message); // Lança erro se a resposta não for 200
          }
        })
        .catch((e) => {
          setData(null); // Se houver erro, limpa os dados
          console.log('Error =>', e.message); // Exibe o erro no console
        })
        .finally(() => {
          setLoading(false); // Define o loading como falso após a operação ser concluída
        });
    }
  }, [token]); // Esse efeito será acionado quando o valor de 'token' mudar

  // A página usa a Capa: a faixa verde com o título que o Header desenhava fica desligada
  useEffect(() => {
    setTitle(null);
    setBgHeader(null);
  }, [setTitle, setBgHeader]);

  // Função para lidar com a mudança do ano selecionado
  const handleYearChange = (value) => {
    setSelectedYear(value); // Atualiza o ano selecionado
  };

  // Se os dados ainda estão sendo carregados, exibe o componente de loading
  if (loading) {
    return <Loading />;
  } else {
    return (
      // Contêiner principal do componente, com posicionamento relativo
      <div style={{ position: 'relative' }}>
        {/* Capa com a imagem do topo, o título e a trilha de navegação */}
        <Capa imagem={data?.imagemHeader?.iv?.[0]} titulo={data?.titulo?.iv} />
        {/* Contêiner com fundo definido dinamicamente */}
        <S.Container bgOurUnits={data?.imagemBackground?.iv[0]}>
          {/* Formulário de filtro com controle do ano */}
          <S.FormFilter>
            <Controller
              name="year"
              control={control}
              defaultValue="" // Valor inicial vazio
              rules={{ required: true }} // Define que o campo é obrigatório
              render={({ field: { onChange } }) => (
                <select
                  onChange={(e) => {
                    onChange(e); // Chama a função do react-hook-form
                    handleYearChange(e.target.value); // Atualiza o ano selecionado
                  }}
                >
                  <option value="">Escolha um ano</option> {/* Opção inicial */}
                  {/* Mapeia as opções de filtro (anos) */}
                  {optionsFilter.map((year) => (
                    <option key={year} value={year}>
                      {year} {/* Exibe o ano no filtro */}
                    </option>
                  ))}
                </select>
              )}
            />
          </S.FormFilter>

          {/* Exibe os eventos, aplicando filtro por ano */}
          {data &&
            [...data?.eventos?.iv] // Cria uma cópia dos eventos para não mutar o estado
              .sort((a, b) => { // Ordena por data, do mais recente para o mais antigo
                const dateA = getEventDate(a);
                const dateB = getEventDate(b);

                if (!dateA && !dateB) return 0; // Sem data em ambos: mantém a ordem original
                if (!dateA) return 1; // Eventos sem data vão para o fim da lista
                if (!dateB) return -1;

                return dateB - dateA; // Ordem decrescente
              })
              .filter((item) => { // Filtra os eventos de acordo com o ano selecionado
                if (!selectedYear) return true; // Se nenhum ano for selecionado, exibe todos os eventos
                const date = getEventDate(item); // Data válida do evento

                return date ? format(date, 'yyyy') === selectedYear : false; // Compara apenas o ano
              })
              .map((item) => {
                const eventDate = getEventDate(item); // Data do evento usada nos dois formatos abaixo

                return (
                  <S.Card key={item?.id}> {/* Componente para exibir o evento */}
                    <S.ContentBox>
                      <h3>
                        {eventDate && (
                          <S.SpanDate>
                            {/* Formata e exibe a data do evento */}
                            {format(eventDate, 'dd MMM', {
                              locale: pt, // Localização em português
                            })}
                          </S.SpanDate>
                        )}
                        {item?.evento?.titulo && item?.evento?.titulo} {/* Exibe o título do evento */}
                      </h3>
                      {eventDate && (
                        <p>
                          Data:
                          <span>
                            {/* Exibe a data completa do evento */}
                            {format(eventDate, "d 'de' MMMM 'de' yyyy", {
                              locale: pt,
                            })}
                          </span>
                        </p>
                      )}
                      {item?.evento?.conteudoAdicional && (
                        <p>
                          Local:
                          <span>{item?.evento?.conteudoAdicional}</span> {/* Exibe o local do evento */}
                        </p>
                      )}
                      {item?.evento?.link?.linkInterno && (
                        <S.LinkHere>
                          Faça sua inscrição
                          <Link to={`${item?.evento?.link?.linkInterno}`}>
                            {` ${item?.evento?.link?.tituloLink}`} {/* Exibe o link de inscrição */}
                          </Link>
                        </S.LinkHere>
                      )}
                    </S.ContentBox>
                    {item?.evento?.imagemEvento !== null && (
                      <img
                        src={`${baseUrlImg}${item?.evento?.imagemEvento[0]}`} // Exibe a imagem do evento
                        alt="imagem do evento"
                      />
                    )}
                  </S.Card>
                );
              })}
        </S.Container>
      </div>
    );
  }
};
